// Editorial background article for the "州选解码" modal (Johor only).
// Stored here (not in public/config.js) so it is not overwritten by the
// dashboard cache pipeline. Blocks are separated by blank lines; a line wrapped
// in <heading>…</heading> is a section title, a bare image URL becomes an inline
// figure, everything else is a paragraph. See BackgroundStories.jsx for parsing.

const johor_zh_CN = `
柔佛是马来半岛最早举行州级选举的州属之一。1954年，在英殖民政府推动地方自治的背景下，柔佛于同年10月10日迎来历史上首次州议会选举，时间甚至早于1955年的马来亚首次全国大选。

回顾历史，1895年4月14日颁布的《1895年柔佛宪法》，这是马来亚首部成文宪法，开启君主立宪制的现代化治理，奠定柔佛现代统治与行政体制的基石，更是延续柔佛州自1895年以来，历经一个多世纪所建立的现代化行政与多元民主遗产。

柔佛在马来西亚建国史创下多项第一，不仅是第一个建立内阁部长理事会的州属，早在1883年就设立“州务大臣”职位，并于1873年引入“宗教司”体制，以巩固州政府的行政体系。马来亚于1957年独立后，柔佛州在1959年8月20日召开首届正式州立法议会。

https://www.orientaldaily.com.my/images/uploads/news/2026/JUN_2026/20260625/WhatsApp_Image_2026-06-25_at_6.38.47_PM.jpeg

<heading>占据大马政坛举足轻重的地位</heading>
作为全国第二大人口州属，也是巫统的发源地，柔佛州在马来西亚政坛向来占据举足轻重的地位。由于拥有高度多元的族群选民结构，柔佛长期被视为最接近全国人口组成的缩影，其选举结果往往被视为全国政治风向的重要指标。

在1959年至1986年的多届选举中，国阵在柔佛维持压倒性优势，平均胜选率高达97%；1995年及1999年更曾横扫全部州议席，使柔佛长期被视为国阵定存州。

https://www.orientaldaily.com.my/images/uploads/news/2026/JUN_2026/20260625/WhatsApp_Image_2026-06-25_at_6.35.33_PM.jpeg

2004年州选选区重划至56席，国阵因新加兰州议席提名失误失去竞选资格，让伊党不战而胜，成为柔佛政治松动的早期信号。

2008年大选后，国阵优势逐步被侵蚀；2013年民联攻下18席，进一步缩小差距。

2018年政治海啸中，希盟夺下柔佛政权，终结国阵长期执政。2020年土团党退出希盟，并与国阵及伊斯兰党组成新联盟，引发喜来登政变，柔佛州议会出现28对28悬峙，最终政权易手，成为首个受该政治变动影响而变天的州属。

柔州议会在2022年1月提前解散，柔佛成为继沙巴、马六甲及砂拉越之后，第四个因政治重组影响而提前举行州选的州属；在同年州选中，国阵以40席大胜重返执政，重新巩固在柔佛的优势地位。

https://www.orientaldaily.com.my/images/uploads/news/2026/JUN_2026/20260625/f14770754ce0c7f89bf9ed2165d28585.jpg

<heading>全国大选前哨战</heading>
根据大马选委会早宣布，第16届柔佛州选将于6月27日提名，7月11日投票。这也是柔佛在8年内迎来第三次州选，频密选举打破过往相对稳定的政治节奏，也凸显其在全国政治布局中的关键角色，被外界视为全国大选的前哨战。

柔佛州政治版图在过去10多年历经剧烈变化，自2013年起，国阵在柔州开始流失部分选区，当年仅赢得56席中的38席；2018年全国大选更在政治海啸冲击下骤减至19席。惟在2022年柔佛州选中出现逆转，国阵成功重夺40个州议席，重新稳住执政地位。

https://www.orientaldaily.com.my/images/uploads/news/2026/JUN_2026/20260625/WhatsApp_Image_2026-06-25_at_6.37.57_PM.jpeg

2020年因“喜来登政变”引发国内政治危机，柔佛州成为继沙巴、马六甲及砂拉越之后，第4个解散州议会并举行州选的州属。2022年3月12日举行的第15届柔佛州选，亦是全国首个落实18岁至20岁自动首投族制度的州选。

目前，由国阵主导的柔佛州政府任期原定至2027年4月届满，惟基于多项考量，包括为让路民主程序及确保州政权稳定。普遍认为，若国阵再次以简单多数掌握柔州政权，将有更大空间在团结政府内进行政治谈判。

<heading>合格选民272万7296人</heading>
根据选委会早前公布的数据，柔佛州共有272万7296名合格选民，其中首投族约12万5762人；族群结构方面，巫裔选民占56.69%、华裔占35.28%、印裔占6.55%。

https://www.orientaldaily.com.my/images/uploads/news/2026/JUN_2026/20260625/WhatsApp_Image_2026-06-25_at_6.36.43_PM.jpeg

由于柔佛选民结构最接近全国人口分布，本届州选被认为胜负关键，仍取决于游子选票与首投族动向。因此，2026年柔佛州选不仅是国阵巩固执政版图的防卫战，更是一场检验民意走向、牵动全国政治风向的前哨战，各政党在此形成的论述与策略，往往更容易被复制至全国大选。
`;

const johor_zh_TW = `
柔佛是馬來半島最早舉行州級選舉的州屬之一。1954年，在英殖民政府推動地方自治的背景下，柔佛於同年10月10日迎來歷史上首次州議會選舉，時間甚至早於1955年的馬來亞首次全國大選。

回顧歷史，1895年4月14日頒布的《1895年柔佛憲法》，這是馬來亞首部成文憲法，開啟君主立憲制的現代化治理，奠定柔佛現代統治與行政體制的基石，更是延續柔佛州自1895年以來，歷經一個多世紀所建立的現代化行政與多元民主遺產。

柔佛在馬來西亞建國史創下多項第一，不僅是第一個建立內閣部長理事會的州屬，早在1883年就設立「州務大臣」職位，並於1873年引入「宗教司」體制，以鞏固州政府的行政體系。馬來亞於1957年獨立後，柔佛州在1959年8月20日召開首屆正式州立法議會。

https://www.orientaldaily.com.my/images/uploads/news/2026/JUN_2026/20260625/WhatsApp_Image_2026-06-25_at_6.38.47_PM.jpeg

<heading>佔據大馬政壇舉足輕重的地位</heading>
作為全國第二大人口州屬，也是巫統的發源地，柔佛州在馬來西亞政壇向來佔據舉足輕重的地位。由於擁有高度多元的族群選民結構，柔佛長期被視為最接近全國人口組成的縮影，其選舉結果往往被視為全國政治風向的重要指標。

在1959年至1986年的多屆選舉中，國陣在柔佛維持壓倒性優勢，平均勝選率高達97%；1995年及1999年更曾橫掃全部州議席，使柔佛長期被視為國陣定存州。

https://www.orientaldaily.com.my/images/uploads/news/2026/JUN_2026/20260625/WhatsApp_Image_2026-06-25_at_6.35.33_PM.jpeg

2004年州選選區重劃至56席，國陣因新加蘭州議席提名失誤失去競選資格，讓伊黨不戰而勝，成為柔佛政治鬆動的早期信號。

2008年大選後，國陣優勢逐步被侵蝕；2013年民聯攻下18席，進一步縮小差距。

2018年政治海嘯中，希盟奪下柔佛政權，終結國陣長期執政。2020年土團黨退出希盟，並與國陣及伊斯蘭黨組成新聯盟，引發喜來登政變，柔佛州議會出現28對28懸峙，最終政權易手，成為首個受該政治變動影響而變天的州屬。

柔州議會在2022年1月提前解散，柔佛成為繼沙巴、馬六甲及砂拉越之後，第四個因政治重組影響而提前舉行州選的州屬；在同年州選中，國陣以40席大勝重返執政，重新鞏固在柔佛的優勢地位。

https://www.orientaldaily.com.my/images/uploads/news/2026/JUN_2026/20260625/f14770754ce0c7f89bf9ed2165d28585.jpg

<heading>全國大選前哨戰</heading>
根據大馬選委會早宣布，第16屆柔佛州選將於6月27日提名，7月11日投票。這也是柔佛在8年內迎來第三次州選，頻密選舉打破過往相對穩定的政治節奏，也凸顯其在全國政治佈局中的關鍵角色，被外界視為全國大選的前哨戰。

柔佛州政治版圖在過去10多年歷經劇烈變化，自2013年起，國陣在柔州開始流失部分選區，當年僅贏得56席中的38席；2018年全國大選更在政治海嘯衝擊下驟減至19席。惟在2022年柔佛州選中出現逆轉，國陣成功重奪40個州議席，重新穩住執政地位。

https://www.orientaldaily.com.my/images/uploads/news/2026/JUN_2026/20260625/WhatsApp_Image_2026-06-25_at_6.37.57_PM.jpeg

2020年因「喜來登政變」引發國內政治危機，柔佛州成為繼沙巴、馬六甲及砂拉越之後，第4個解散州議會並舉行州選的州屬。2022年3月12日舉行的第15屆柔佛州選，亦是全國首個落實18歲至20歲自動首投族制度的州選。

目前，由國陣主導的柔佛州政府任期原定至2027年4月屆滿，惟基於多項考量，包括為讓路民主程序及確保州政權穩定。普遍認為，若國陣再次以簡單多數掌握柔州政權，將有更大空間在團結政府內進行政治談判。

<heading>合格選民272萬7296人</heading>
根據選委會早前公布的數據，柔佛州共有272萬7296名合格選民，其中首投族約12萬5762人；族群結構方面，巫裔選民佔56.69%、華裔佔35.28%、印裔佔6.55%。

https://www.orientaldaily.com.my/images/uploads/news/2026/JUN_2026/20260625/WhatsApp_Image_2026-06-25_at_6.36.43_PM.jpeg

由於柔佛選民結構最接近全國人口分布，本屆州選被認為勝負關鍵，仍取決於遊子選票與首投族動向。因此，2026年柔佛州選不僅是國陣鞏固執政版圖的防衛戰，更是一場檢驗民意走向、牽動全國政治風向的前哨戰，各政黨在此形成的論述與策略，往往更容易被複製至全國大選。
`;

export const backgroundArticles = {
  johor: { zh_CN: johor_zh_CN, zh_TW: johor_zh_TW },
};

export default backgroundArticles;
